module.exports = __webpack_public_path__ + "media/smart_sales/icon-1-13688124.svg";